/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as core from '../../core';
import * as errors from '../../errors/index';
import * as Truvity from '../index';

export class MethodNotAllowedError extends errors.TruvityError {
    constructor(body: Truvity.MethodNotAllowedProblems, rawResponse?: core.RawResponse) {
        super({
            message: 'MethodNotAllowedError',
            statusCode: 405,
            body: body,
            rawResponse: rawResponse,
        });
        Object.setPrototypeOf(this, MethodNotAllowedError.prototype);
    }
}
